import { Component, OnInit } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';

import { AuthService } from '../services/auth.service';
import { EnvService } from '../services/env.service';
import { CommonService } from '../services/common.service';

@Component({
	selector: 'app-payment',
	templateUrl: './payment.component.html',
	styleUrls: ['./payment.component.css']
})
export class PaymentComponent implements OnInit {

	pageObj:any = "curr";

	frm : FormGroup;

	constructor(
		private http: HttpClient,
		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) { }

	ngOnInit() {
	}

}
